import type { HTMLAttributes, KeyboardEvent } from 'react';

export type CardElement = 'div' | 'section' | 'article';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: CardElement;
  interactive?: boolean;
  selected?: boolean;
}

export function Card({
  as: Component = 'div',
  interactive = false,
  selected = false,
  className,
  role,
  tabIndex,
  onKeyDown,
  ...cardProps
}: CardProps) {
  const classes = [
    'ui-card',
    interactive ? 'ui-card--interactive' : '',
    selected ? 'ui-card--selected' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  function handleKeyDown(event: KeyboardEvent<HTMLElement>) {
    onKeyDown?.(event);
    if (!interactive || event.defaultPrevented || !cardProps.onClick) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  return (
    <Component
      {...cardProps}
      className={classes}
      role={role ?? (interactive ? 'button' : undefined)}
      tabIndex={tabIndex ?? (interactive ? 0 : undefined)}
      aria-pressed={interactive ? selected : undefined}
      data-selected={selected || undefined}
      onKeyDown={handleKeyDown}
    />
  );
}
